<template>
  <div>
    <h2>Синхронизация данных о запросах в СМЭВ</h2>
    <div class="left shedule-header">
      <h3 class="shedule-title">Интервал синхронизации</h3>
      <p>Значение задается в минутах.</p>
      <p>При значении <code>0</code> синхронизации не происходит.</p>
    </div>
    <div>
      <div class="centered shedule-controls smev-requests-sync-input-container">
        <input
          type="number"
          class="input shedule-input"
          v-model="syncInterval"
          min="0"
        />
        <button
          @click="setSyncInterval"
          @disabled="this.disabled"
          class="button"
        >
          {{ this.disabled ? 'Идет сохранение...' : 'Сохранить' }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SmevRequestSync',
  mounted() {
    this.getSyncInterval()
  },
  data() {
    return {
      error: null,
      syncInterval: 0,
      disabled: false
    }
  },
  props: {

  },
  methods: {
    async getSyncInterval() {
      const { data } = await this.axios.get('/uprid/smev-requests-sync-interval')

      this.syncInterval = data.syncInterval
    },
    async setSyncInterval() {
      this.disabled = true

      await this.axios
        .put('/uprid/smev-requests-sync-interval', { syncInterval: this.syncInterval })
        .catch((e) => {
          this.disabled = false
        })


      this.disabled = false
    }
  }
}
</script>

<style>
.smev-requests-sync-input-container {
  margin-left: 0;
}
</style>



// WEBPACK FOOTER //
// SmevRequestsSync.vue?590d5a20